import { CustomDoc } from "./../../vo/custom-doc";
import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	AfterViewInit,
} from "@angular/core";
import { AppHeaderModelService } from "./app-header-model.service";
import { CourseContextModelService } from "../../models/course-context-model.service";
import { Subscription } from "rxjs";
import { UtilityScripts } from "app/helpers/utility-scripts";
import { DescriptorModelService } from "app/core/models/descriptor-model.service";
import { ModalPopupService } from "app/services/modal-popup.service";
import { TrackingManager } from "app/core/tracking/tracking-manager";
import { AppServices } from "app/app.services";
import { ScreenControllerService } from "app/core/controls/screen-controller.service";
import { CourseControllerService } from "app/core/controls/course-controller.service";
import { ApplicationModel } from "../../models/application.model";
import { ApplicationUtilityService } from "../../../services/application-utility.service";
import { OrientationModelService } from "app/core/models/orientation-model.service";

@Component({
	selector: "app-app-header",
	templateUrl: "./app-header.component.html",
	styleUrls: ["./app-header.component.css"],
})
export class AppHeaderComponent implements OnInit {
	public fullImagePath: string;
	public toggleUser = "page-top-header-user-nav";
	public toggleDocs = false;
	private updateScreenSubscription: Subscription;

	@Input() textDirection: string;
	@Input() header_inner_wrap: string;
	@Output() toggleIW = new EventEmitter<string>();
	@Output() languageUpdate = new EventEmitter<string>();

	constructor(
		private appheaderModelService: AppHeaderModelService,
		private courseContextModelService: CourseContextModelService,
		private descriptorService: DescriptorModelService,
		private popupService: ModalPopupService,
		private appServices: AppServices,
		public CourseControllerService: CourseControllerService,
		private screenController: ScreenControllerService,
		private appUtilityService: ApplicationUtilityService,
		public orientationModel: OrientationModelService
	) {
		this.fullImagePath = "assets/ng_logo.svg";
		this.updateScreenSubscription =
			this.courseContextModelService.notifier.subscribe((data) => {
				this.closeDocs(data);
			});
	}

	ngOnInit() {
		console.log(
			"UtilityScripts.isMobileDevice  :" + UtilityScripts.isMobileDevice()
		);
	}

	toggleInnerWrap(event) {
		if (this.header_inner_wrap === "page-inner-wrap") {
			this.header_inner_wrap = "page-inner-wrap toggled";
			this.appServices.emitMenuToggle("open");
		} else {
			this.header_inner_wrap = "page-inner-wrap";
			this.appServices.emitMenuToggle("close");
		}
		this.toggleIW.emit(this.header_inner_wrap);
	}

	toggleUserNav(event) {
		if (this.toggleUser === "page-top-header-user-nav") {
			this.toggleUser = "page-top-header-user-nav open";
		} else {
			this.toggleUser = "page-top-header-user-nav";
		}
	}

	toggleDocNav(event) {
		this.toggleDocs = !this.toggleDocs;
	}

	langSelect(event) {
		// console.log("langSelect  ",event);
		ApplicationModel.instance.flowDirection = this.textDirection =
			event.direction;
		this.languageUpdate.emit(event.language);
		//this.CourseControllerService.updateGeoLocation();
	}
	private documentClick(doc) {
		// doc.isVisible = !doc.isVisible;
		doc.isVisible = true;
		ApplicationModel.instance.videoOverlay = true;
		this.appServices.pauseVideo();
		this.appheaderModelService.customDocs.forEach((item) => {
			if (doc.iconTarget !== item.iconTarget) {
				item.isVisible = false;
			}
		});
		this.courseContextModelService.customDoc = doc.isVisible ? doc : null;
	}
	private closeDocs(data) {
		this.appheaderModelService.customDocs.forEach((item) => {
			item.isVisible = false;
		});
		this.courseContextModelService.customDoc = null;
	}
	public get appheaderModelServiceVal(): AppHeaderModelService {
		// console.log(this.appheaderModelService.customDocs);
		return this.appheaderModelService;
	}
	public exitButtonClickHandler() {
		this.appUtilityService.pauseCoursePlayer();
		this.appUtilityService.exitCourse();
	}
	public isMobile() {
		return UtilityScripts.isMobileDevice();
	}
	public get trackingManager() {
		return TrackingManager.instance;
	}
}
